import * as React from "react";
import classnames from "classnames";
/* empty css                 */
const CardWrapper = ({
  children,
  className,
  ...rest
}) => /* @__PURE__ */ React.createElement("div", { "data-t": rest["data-t"], className: classnames("card", className) }, children);
export {
  CardWrapper as default
};
//# sourceMappingURL=CardWrapper.js.map
